var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vi-input"},[_c('label',[_c('input',{ref:"input",attrs:{"type":_vm.type,"placeholder":_vm.label,"disabled":_vm.disabled,"autocapitalize":"off"},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})])])}
var staticRenderFns = []

export { render, staticRenderFns }